import { GLOBAL_ANALYTICS_EVENT_NAME, GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME } from './constants';
import type { PageLoadEventParam } from './types/analytics';
import type { EventSender, GlobalAnalyticsEventDetails } from './types';
import { postProcessing } from './postProcessing';

if (process.env.NODE_ENV === 'development') {
  window.addEventListener(
    GLOBAL_ANALYTICS_EVENT_NAME,
    (event: CustomEvent<GlobalAnalyticsEventDetails>): void => {
      // eslint-disable-next-line no-console
      console.info('📈 GA EVENT from UIaaS', event.detail);
    },
  );
}

export const send: EventSender = (eventDetailsBuilder, params) => {
  const event = new CustomEvent(GLOBAL_ANALYTICS_EVENT_NAME, {
    detail: postProcessing(eventDetailsBuilder(params)),
    bubbles: true,
    composed: true,
  });

  window.dispatchEvent(event);
};
export const updatePageLoadData = (params: PageLoadEventParam) => {
  const event = new CustomEvent(GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME, {
    detail: params,
    bubbles: true,
    composed: true,
  });

  window.dispatchEvent(event);
};
